import loadable from '@loadable/component';
import FullPageLoading from '../../../components/Loading/FullPageLoading';
import { T_CHALLENGE_PACK_PATH } from '../challenge-pack/challenge-pack.lazy';

export const T_SEND_CHALLENGE_PACK_PATH = `${T_CHALLENGE_PACK_PATH}/send`;

export const SendChallengePackLazy = loadable(async () => import('./send-challenge-pack.view'), {
  fallback: <FullPageLoading />,
});
